// const server = "http://localhost";
// const domain = "localhost";
// const port = 9201;
const server = "https://apisms.mansolutions.app";
const domain = "adminsms.mansolutions.app";
const port = 443;
export { server, port, domain };
